import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Card, Notify } from 'vant'
import 'vant/lib/index.css'

import './utils/error-log' // error log

Vue.use(Card)
Vue.use(Notify)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
